import * as ValidationRule from "../utils/ValidationRule";
import * as yup from "yup";

export const RequiredFieldTypes = {
    STRING: "STRING",
    DECIMAL: "DECIMAL",
    ENUM: "ENUM",
    LONG: "LONG",
    DATE: "DATE",
    TIME: "TIME",
    COUNTRY: "COUNTRY",
    CURRENCY: "CURRENCY",
    ALPHA_SPACE: "ALPHA_SPACE",
    MSISDN: "MSISDN",
    ALPHA_NUMERIC: "ALPHA_NUMERIC"
};

export function stringValidator(field, customText, required, min, max) {
    return yup.object().shape({
        [field]: ValidationRule.getStringRule(customText, required, min, max)
    });
}

export function decimalValidator(field, customText, required) {
    return yup.object().shape({
        [field]: ValidationRule.getDecimalRule(customText, required)
    });
}

export function enumValidator(field, customText, required) {
    return yup.object().shape({
        [field]: ValidationRule.getAlphaSpaceValidator(customText, required)
    });
}

export function longValidator(field, customText, required) {
    return yup.object().shape({
        [field]: ValidationRule.getIntegerRule(customText, required)
    });
}

export function dateValidator(field, requiredText, required) {
    return yup.object().shape({
        [field]: ValidationRule.getDOBValidator(requiredText, required)
    });
}

export function dateValidatorIdExpiry(field, requiredText, required) {
    return yup.object().shape({
        [field]: ValidationRule.getIdExpiryDateValidator(requiredText, required)
    });
}

export function defaultDateValidator(field, requiredText, required) {
    return yup.object().shape({
        [field]: ValidationRule.getStringRule(requiredText, required)
    });
}

export function timeValidator(field, requiredText, required) {
    return yup.object().shape({
        [field]: ValidationRule.getStringRule(requiredText, required)
    });
}

export function alphaSpaceValidator(field, requiredText, required) {
    return yup.object().shape({
        [field]: ValidationRule.getAlphaSpaceValidator(requiredText, required)
    });
}

export function msisdnValidator(field, customText, required) {
    return yup.object().shape({
        [field]: ValidationRule.getInternationalCellphoneNumberRule(customText, required)
    });
}

export function alphaNumericValidator(field, requiredText, required) {
    return yup.object().shape({
        [field]: ValidationRule.getAlphaNumericValidator(requiredText, required)
    });
}